'use strict';

export function serializeArray(form) {
    var field, l, s = [];
    if (typeof form == 'object' && form.nodeName == "FORM") {
        var len = form.elements.length;
        for (var i=0; i<len; i++) {
            field = form.elements[i];
            if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
                if (field.type == 'select-multiple') {
                    l = form.elements[i].options.length; 
                    for (var j=0; j<l; j++) {
                        if(field.options[j].selected)
                            var k = field.name;
                            var v = field.options[j].value;
                            s[s.length] = { [k] : v };
                    }
                } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                    var k = field.name;
                    var v = field.value;
                    s[s.length] = { [k] : v };
                }
            }
        }
    }
    return s;
}

export function arraytojson(array){
    console.log(typeof array);
    if(typeof array == 'object'){
        let obj = {};
        for (var x = 0; x < array.length; x++) {
            obj[array[x].name] = array[x].value;
        }
        return(obj);
    }else{
        throw new Error('input is not an array');
    }
}

export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}



// WEBPACK FOOTER //
// ./src/js/utils.js